import { render, staticRenderFns } from "./ModelEditHandler.vue?vue&type=template&id=d3bb0d08"
import script from "./ModelEditHandler.vue?vue&type=script&lang=ts"
export * from "./ModelEditHandler.vue?vue&type=script&lang=ts"
import style0 from "./ModelEditHandler.vue?vue&type=style&index=0&id=d3bb0d08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports